(function($){
    $.PrefetchContent = function(options) {
        this._component_name = "prefetch_content";
        this._loaded = [];
        this._on('ready', $.Component.bind(this, $.PrefetchContent));
    };

    $.Component.create($.PrefetchContent, {
        _init: function(options) {
            this._options = options || {};
            this._urls = this._options.urls || [];

            for (var index = 0; index < this._urls.length; index++) {
                var url = this._urls[index];
                this._load(url, this._callback.bind(this));                
            } 

            this._check_loaded();
        },

        _callback: function(url) {
            this._loaded.push(url);
            this._check_loaded();
        },

        _check_loaded: function() {
            if (this._loaded.length == this._urls.length) {
                this._emit('ready');
            }
        },

        _load: function(url, callback_func, error_func) {
            var request = new XMLHttpRequest();
            request.addEventListener('load', function(evt) {
                if (request.status == 0 || (request.status >= 200 && request.status < 299)) {
                    var div = document.createElement('div');
                    div.innerHTML = request.responseText;
                    for ( ; div.children.length > 0; ) {
                        var child_element = div.children[div.children.length - 1];
                        document.body.appendChild(child_element);
                    }

                    if (callback_func) { callback_func(url); }
                }
                else {
                    if (error_func) { error_func(url); }
                }
            });

            request.open('GET', url);
            request.send();
        },
    }, $.OSD); 

})(ABDOMap);